module.exports = __webpack_public_path__ + "img/globe.c95eb3d.svg";